import { FeeCategory } from '../api/feeCategoriesApi';
import { MeterReadingType } from '../api/meterReadingsApi';
import { matchesMeterReadingType } from './usageFeeCategoryMatching';

function isTieredUsageFeeCategory(category: FeeCategory): boolean {
  return category.pricingType === 'TIERED' && !category.isMonthlyFixed;
}

export function findUsageFeeCategoryForMeterType(
  categories: FeeCategory[],
  type: MeterReadingType,
): FeeCategory | undefined {
  return categories.find(
    (category) => isTieredUsageFeeCategory(category) && matchesMeterReadingType(category, type),
  );
}
